module.exports = __webpack_public_path__ + "media/images/nutri_ads/restilen_750x90_2-6540ac03c517f407119736c42ce9065d.jpg";